import { Phantom } from "./phantom"
import { Solflare } from "./solflare"

export const SolanaWallets = {
    phantom: Phantom,
    solflare: Solflare
}